import imageDisplaySizeData from './generated/image-display-sizes'

import type {
    AspectRatio,
    ImageSizeData,
    ImageSizesForEachAspectRatio,
    ImageSizeMapInterface,
} from 'src/components/image/shared'

export type SizeName = keyof typeof imageDisplaySizeData

const sizeMap = imageDisplaySizeData as ImageSizeData

/**
 * Standard image display sizes, based on our 12-column grid in Figma
 * (and 4-column grid for phones).
 *
 * Each display size is technically a size range and not just a specific size. The sizes
 * stored in this class reflect the maximum possible width/height for that size.
 * For more explanation, see the image size generation script in scripts/generate-image-sizes.
 */
class ImageDisplaySizeMap
    extends Map<SizeName, ImageSizesForEachAspectRatio>
    implements ImageSizeMapInterface
{
    getDimensions(aspectRatio: AspectRatio, sizeName: SizeName) {
        return this.get(sizeName)?.[aspectRatio]
    }
}

export const imageDisplaySizes = new ImageDisplaySizeMap(
    Object.entries(sizeMap) as Array<[SizeName, ImageSizesForEachAspectRatio]>
)
